import { observable, action, decorate } from 'mobx'
import { The } from '../helpers/generalHelpers'
import { getInvitationList } from '../api/api'

class invitationStore {
  isLoading = false

  invitations = []
  setInvitationsList = (newInvitationsList) => {
    this.invitations = newInvitationsList
  }
  setIsLoading = (bool) => {
    this.isLoading = bool
  }
}

decorate(invitationStore, {
  isLoading: observable,
  invitations: observable,
  setInvitationsList: action,
  setIsLoading: action,
})

const InvitationStore = new invitationStore()

export async function fetchInvitationsList() {
  InvitationStore.setIsLoading(true)
  const [err, res] = await The(getInvitationList())

  if (err) {
    InvitationStore.setIsLoading(false)
    throw new Error(err)
  }

  if (res) {
    InvitationStore.setInvitationsList(res.invitations)
    InvitationStore.setIsLoading(false)
    return res.invitations
  }

  InvitationStore.setIsLoading(false)
  return null
}

export default InvitationStore
